import React from "react";
import BaseInput from "./BaseInput";

const EmailInput = (props) => {
    return (
        <BaseInput type="email" {...props} />
    );
};

export default EmailInput;